// Los pasos del chatbot demo que dibujan una sección de la página de producto
// (/eureka/, /documentacion-pie/…) a ancho completo. Los usan las demos de Eureka,
// Planificaciones y Pruebas informales.
import ServiceContent from "./ServiceContent.vue";

// ChatMessageComponent monta los `custom-component` FUERA de la burbuja del
// chat (ver `.box-answer`), que es donde este contenido se puede leer: en
// tarjetas dentro de la burbuja las cifras, los planes y el FAQ quedaban
// diminutos. `extra` pisa cualquier campo: el siguiente paso, el texto del
// botón, `dontShowNextButton` para encadenar solo, o un `component` propio.
export const sectionStep = (name, text, extra) => ({
  name,
  text,
  type: "custom-component",
  component: null,
  single_choice: false,
  answersLoaded: true,
  answers: [],
  nextQuestionIndex: "mainMessage",
  routine() {},
  ...extra,
});

// El envoltorio que le pasa las props a ServiceContent. ChatMessageComponent
// solo enlaza condition/context/canWork en el componente dinámico, así que la
// configuración se cierra acá dentro (el mismo truco de PieDemo).
// `color` es el acento del producto; `colorInk`, su versión oscura para texto.
export const sectionComponent = (content, block, color, colorInk) => ({
  name: `svc-${block}`,
  render(h) {
    return h(ServiceContent, {
      props: { content, block, color, colorInk },
      on: { "go-to-step": (step) => this.$emit("go-to-step", step) },
    });
  },
});
